import { all, takeEvery, takeLatest, put, fork } from "redux-saga/effects";
import constants from "./CONSTANTS";
import actions from "src/store/auth/actions";
import mainAxios from "src/settings/axios";
import { toast } from "react-toastify";

export function* loginRequest() {
  yield takeLatest(constants.LOGIN_REQ, function* (action) {
    yield put(actions.loading(true));

    try {
      const { data } = yield mainAxios.post("/services/auth/Authenticate", {
        UserName: action.userName,
        Password: action.password,
      });

      if (data.success) {
        localStorage.setItem("act", data.data.accessToken);
        localStorage.setItem("rft", data.data.refreshToken);
        localStorage.setItem("alm", data.data.autoLogoutMinute);

        yield put(actions.loginSuccess({ UserName: action.userName }));
        yield put(actions.userMustChangePassword(data.data.userMustChangePassword))
        yield put(actions.loading(false));
      }
    } catch (e) {
      console.log(e);
      yield put(actions.loading(false));
    }
  });
}

export const USER_PASS_INCORRECT = 'USER_PASS_INCORRECT';
export function* ChangeUserPassword() {
  yield takeLatest(constants.CHANGE_USER_PASSWORD, function* (action) {
    try {
      yield put(actions.loading(true));

      const { data } = yield mainAxios.patch("/services/capp/admin/mu/ChangeUserPassword", {
        OldPassword: action.oldPassword,
        NewPassword: action.newPassword,
      });

      if (data.success) {
        console.log("success");
        toast.success("პაროლი წარმატებით შეიცვალა");
        yield put(actions.loading(false));
        yield put(actions.userMustChangePassword(false))
      }
    } catch (e) {
      if (e.response.data.ExceptionCode === USER_PASS_INCORRECT) {
        toast.error("პაროლის შეცვლა ვერ მოხერხდა");
      } else {
        toast.error("მომხმარებლის პაროლი არასწორია");
      }
      yield put(actions.loading(false));
      console.log(e);
    }
  });
}


export function* logoutRequest() {
  yield takeEvery(constants.LOGOUT_USER, function* (action) {
    try {
      localStorage.removeItem("act");
      localStorage.removeItem("rft");
      localStorage.removeItem("alm");

      toast.dismiss(); // remove all toasts

      yield put(actions.resetAll());
    } catch (e) {
      console.log(e);
    }
  });
}

export function* GetApprovalsExpirationStatus() {
  yield takeLatest(constants.GET_APPROVAL_EXPIRATION_STATUS, function* (action) {
    try {
      yield put(actions.loading(true));

      const { data } = yield mainAxios.get("/services/ccp/appr/GetApprovalsExpirationStatus");

      if (data.success) {
        yield put(actions.setApprovalsExpirationStatus(data.data));
        yield put(actions.loading(false));
      }
    } catch (e) {
      yield put(actions.loading(false));
      console.log(e);
    }
  });
}

// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(loginRequest),
    fork(logoutRequest),
    fork(ChangeUserPassword),
    fork(GetApprovalsExpirationStatus)
  ]);
}
